import Vue from 'vue'
import Router from 'vue-router'
import VueGtag from "vue-gtag"


let default_lang = 'pt';

if(localStorage.getItem('lang') === null) {
  localStorage.setItem('lang', default_lang);
}

// Containers
const DefaultContainer = () => import('@/containers/DefaultContainer')

// Views
const Dashboard = () => import('@/views/Dashboard')

const Colors = () => import('@/views/theme/Colors')
const Typography = () => import('@/views/theme/Typography')

const Charts = () => import('@/views/Charts')
const Widgets = () => import('@/views/Widgets')

// Views - Components
const Cards = () => import('@/views/base/Cards')
const Forms = () => import('@/views/base/Forms')
const Switches = () => import('@/views/base/Switches')
const Tables = () => import('@/views/base/Tables')
const Tabs = () => import('@/views/base/Tabs')
const Breadcrumbs = () => import('@/views/base/Breadcrumbs')
const Carousels = () => import('@/views/base/Carousels')
const Collapses = () => import('@/views/base/Collapses')
const Jumbotrons = () => import('@/views/base/Jumbotrons')
const ListGroups = () => import('@/views/base/ListGroups')
const Navs = () => import('@/views/base/Navs')
const Navbars = () => import('@/views/base/Navbars')
const Paginations = () => import('@/views/base/Paginations')
const Popovers = () => import('@/views/base/Popovers')
const ProgressBars = () => import('@/views/base/ProgressBars')
const Tooltips = () => import('@/views/base/Tooltips')

// Views - Buttons
const StandardButtons = () => import('@/views/buttons/StandardButtons')
const ButtonGroups = () => import('@/views/buttons/ButtonGroups')
const Dropdowns = () => import('@/views/buttons/Dropdowns')
const BrandButtons = () => import('@/views/buttons/BrandButtons')

// Views - Icons
const Flags = () => import('@/views/icons/Flags')
const FontAwesome = () => import('@/views/icons/FontAwesome')
const SimpleLineIcons = () => import('@/views/icons/SimpleLineIcons')
const CoreUIIcons = () => import('@/views/icons/CoreUIIcons')

// Views - Notifications
const Alerts = () => import('@/views/notifications/Alerts')
const Badges = () => import('@/views/notifications/Badges')
const Modals = () => import('@/views/notifications/Modals')

// Views - Pages
// const Page404 = () => import('@/views/pages/Page404')
const Page500 = () => import('@/views/pages/Page500')
const Login = () => import('@/views/pages/Login')
const Register = () => import('@/views/pages/Register')

// Users
const Users = () => import('@/views/users/Users')
const User = () => import('@/views/users/User')

Vue.use(Router)

var router = new Router({
  mode: process.env.VUE_APP_ROUTER_MODE,
  base: process.env.VUE_APP_ROUTER_BASE,
  linkActiveClass: 'open active',
  // props: true,
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      redirect: '/' +localStorage.getItem('lang')+ '/codigos-postais/codigo-postal',
      name: 'HomeContainer',
      component: DefaultContainer,
      meta: {
        label: 'home',
        trans_key: 'Home'
      }
    },
    {
      path: '/:lang',
      redirect: '/:lang/codigos-postais/codigo-postal',
      name: 'Home',
      component: DefaultContainer,
      meta: {
        label: 'home',
        trans_key: 'Home'
      },
      children: [
        {
          redirect: '/:lang/codigos-postais/codigo-postal',
          path: 'codigos-postais/',
          meta: {
            label: 'nav_zip_codes'
          },
          name: 'ZipCodes',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              meta: {
                trans_key: 'Zip_Codes',
                label: 'nav_zip_code'
              },
              name: 'ZipCode',
              path: 'codigo-postal/:search_param?',
              component: () => import(/* webpackChunkName: "zip_codes" */ '@/views/components/Zip_Codes.vue')
            },
            {
              meta: {
                trans_key: 'Zip_Codes',
                label: 'nav_cp4_verification'
              },
              name: 'CP4',
              path: 'cp4/:search_param?',
              component: () => import(/* webpackChunkName: "zip_codes" */ '@/views/components/Cp4_Validation.vue')
            },
          ]
        },
        {
          path: 'general',
          redirect: '/:lang/general/enviroment-expenses',
          name: 'general',
          meta: {
            label: "general"
          },
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              name: 'Enviroment_Expenses',
              meta: {
                trans_key: 'Enviroment_Expenses',
                start_end_point: 'districts/all',
                years_end_point: 'districts/get_years/enviroment_expenses',
                data_end_point: 'districts/get_enviroment_expenses',
                label: "nav_env_expenses"
              },
              path: 'enviroment-expenses/:id?/:slug?',
              component: () => import(/* webpackChunkName: "general_comp" */'@/views/components/General_Comp.vue')
            },
            {
              name: 'Birth_Rate',
              meta: {
                trans_key: 'Birth_Rate',
                /*default_opt1: {id: 0, text: 'Total', name: 'Total'},*/
                start_end_point: 'districts/all',
                years_end_point: 'districts/get_years/birth_rates',
                data_end_point: 'districts/get_birth_rates',
                label: "nav_birth_rate"
              },
              path: 'birth-rate/:id?/:slug?',
              component: () => import(/* webpackChunkName: "general_comp" */'@/views/components/General_Comp.vue')
            }
          ]
        },
        {
          name: 'Admin',
          path: 'div-admin',
          redirect: '/:lang/div-admin/distritos',
          meta: {
            label: "nav_div_admin"
          },
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              name: 'Admin_Districts',
              meta: {
                trans_key: 'Admin_Districts',
                label: "nav_districts"
              },
              path: 'distritos/:id?/:slug?',
              component: () => import(/* webpackChunkName: "admin_districts" */'@/views/components/Admin_Districts.vue')
            },
            {
              name: 'Admin_Counties',
              meta: {
                trans_key: 'Admin_Counties',
                label: "nav_counties"
              },
              path: 'concelhos/:id?/:slug?',
              component: () => import(/* webpackChunkName: "admin_counties" */ '@/views/components/Admin_Counties.vue')
            },
            {
              name: 'Admin_Fregs',
              meta: {
                trans_key: 'Admin_Fregs',
                label: 'nav_fregs'
              },
              path: 'freguesias/concelho/:id_county?/freguesia/:id?/:slug?',
              component: () => import(/* webpackChunkName: "admin_fregs" */ '@/views/components/Admin_Fregs.vue')
            },
          ]
        },
        {
          path: 'demografia',
          redirect: '/:lang/demografia/distritos',
          name: 'Demographic',
          meta: {
            label: "nav_demo_data"
          },
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              name: 'Demographic_Districts',
              meta: {
                trans_key: 'Demo_Districts',
                label: "nav_districts"
              },
              path: 'distritos/:id?/:slug?',
              component: () => import(/* webpackChunkName: "demo_districts" */ '@/views/components/Demo_Districts.vue')
            },
            {
              name: 'Demographic_Counties',
              meta: {
                trans_key: 'Demo_Counties',
                label: 'nav_counties'
              },
              path: 'concelhos/:id?/:slug?',
              component: () => import(/* webpackChunkName: "demo_counties" */'@/views/components/Demo_Counties.vue')
            },
            {
              name: 'Demographic_Fregs',
              meta: {
                trans_key: 'Demo_Fregs',
                label: 'nav_fregs',
              },
              path: 'freguesias/:id?/:slug?',
              component: () => import(/* webpackChunkName: "demo_fregs" */'@/views/components/Demo_Fregs.vue')
            },
          ]
        },
        {
          path: 'simuladores',
          redirect: '/:lang/simuladores/vencimento-liquido',
          meta: {
            label: 'nav_simulators'
          },
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              name: 'Net_Salary',
              meta: {
                trans_key: 'Net_Salary',
                label: "nav_net_salary"
              },
              path: 'vencimento-liquido',
              component: () => import(/* webpackChunkName: "net_salary" */'@/views/components/Net_Salary.vue')
            },
          ]
        },
        {
          path: 'servicos/',
          redirect: '/:lang/servicos/police-stations',
          name: 'services',
          meta: {
            label: "nav_services"
          },
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              name: 'Hypermarkets',
              meta: {
                trans_key: 'Hypermarkets',
                label: 'nav_hypermarkets'
              },
              path: 'hipermercados/:id?/:hypermarket_slug?/:id_county?/:slug?',
              component: () => import(/* webpackChunkName: "hypermarkets" */'@/views/components/Hypermarkets.vue')
            },
            {
              name: 'Police_Stations',
              meta: {
                trans_key: 'Police_Stations',
                label: "nav_police_stations"
              },
              path: 'police-stations/:id_county?/:slug?',
              component: () => import(/* webpackChunkName: "police_stations" */'@/views/components/Police_Stations.vue')
            },
            {
              name: 'Fire_Departments',
              meta: {
                trans_key: 'Fire_Departments',
                label: "nav_fire_departments"
              },
              path: 'quarteis-bombeiros/:id_county?/:slug?',
              component: () => import(/* webpackChunkName: "fire_departments" */'@/views/components/Fire_Departments.vue')
            },
            {
              meta: {
                
              },
              name: 'ExampleMap',
              path: 'example-map',
              component: () => import(/* webpackChunkName: "fire_departments" */'@/views/components/ExampleMap.vue')
            },
          ]
        },
        {
          path: 'sources',
          name: 'Sources',
          meta: {
            label: 'nav_sources'
          },
          component: () => import(/* webpackChunkName: "net_salary" */'@/views/components/Sources.vue'),
        },
      ]
    },
    {
      path: '/:lang/',
      // redirect: '/' +localStorage.lang+ '/404',
      component: DefaultContainer,
      children: [
        {
          name: 'Error_404',
          meta: {
            label: 'Error 404'
          },
          path: "*",
          component: () => import('@/views/components/errors/Error_404')
        }
      ]
    }
    //{ path: "*", component: Page404, name: 'error404' }
  ]
})

window.allowed_langs = ['en', 'pt'];
router.beforeEach((to, from, next) => {

  if(allowed_langs.indexOf(to.params.lang) === -1) {
    router.push({name: from.name, params: from.params});
    return;
  }

  if(to.params.lang !== from.params.lang) {
    localStorage.setItem('lang', to.params.lang);
    Vue.prototype.$trans = require('@/langs/trans/' +localStorage.lang+ '.js')['default'];
  }
  else if(typeof Vue.prototype.$trans === 'undefined') {
    Vue.prototype.$trans = require('@/langs/trans/' +localStorage.lang+ '.js')['default'];
  }

  Vue.prototype.$lang = localStorage.lang;
  document.title = 'Central Info Portugal - ' +Vue.prototype.$trans['general'][to.meta.label];
  next();
});

if(process.env.NODE_ENV === 'production') {
  Vue.use(VueGtag, {
    config: {id: "G-3PREF67HWY" }
  }, router);
}

export default router;

// SITEMAP XML

/*function getRoutesList(routes, pre) {
  return routes.reduce((array, route) => {
    const path = `${pre}${route.path}`;

    if (route.path !== '*') {
      array.push(path);
    }

    if (route.children) {
      array.push(...getRoutesList(route.children, `${path}/`));
    }

    return array;
  }, []);
}

getRoutesList(router.options.routes, 'https://zigamiklic.com');

function getRoutesXML() {
  const list = getRoutesList(router.options.routes, 'https://www.centralinfo.pt')
    .map(route => `<url><loc>${route.replace(':lang', 'pt')}</loc></url>`)
    .join('\r\n');
  return `<?xml version="1.0" encoding="utf-8"?><urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xsi:schemaLocation="http://www.sitemaps.org/schemas/sitemap/0.9 http://www.sitemaps.org/schemas/sitemap/0.9/sitemap.xsd">
    ${list}
  </urlset>`;
}

console.log(getRoutesXML());*/